import React from 'react'

import { formatNumber } from '../../../../../utilities/helpers'

import Card from 'react-bootstrap/Card'
import Stack from 'react-bootstrap/Stack'

import { assignedSeatCount } from '../../../offerAvailability'

export default function InventoryCard({
  type,
  name,
  inventory,
  holds,
  kills,
  tickets,
}) {
  const getText = (inventory) => {
    if (inventory && inventory?.gaSeats) {
      const numSeats = assignedSeatCount(inventory, {
        holds,
        kills,
        tickets,
        offer: inventory,
      })
      if (numSeats == null) return 'No seats assigned'
      return `${formatNumber(numSeats)} ${numSeats === 1 ? 'seat' : 'seats'}`
    }
  }

  return (
    <>
      <Card body className="card--sm card-with-border">
        <div className="card-body-heading card-body-heading--sm">
          <Card.Title as="h5" className="card-title-xs card-title-thin">
            {type === 'open'
              ? 'All offers using Open will share the same set of seats'
              : 'This offer will exclusively sell the seats assigned to this inventory set'}
          </Card.Title>
        </div>
        <Stack direction="horizontal" className="heading--flex-space-between">
          <Stack direction="horizontal" className="flex-sm">
            <div
              className="dot align-self-start"
              style={{
                backgroundColor: inventory?.color,
              }}
            ></div>
            <Stack>
              <span className="item-name">{`${name || '(Name needs to be assigned)'}`}</span>
              <span className="subtitle">{getText(inventory)}</span>
            </Stack>
          </Stack>
        </Stack>
      </Card>
    </>
  )
}
